import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M13.925 4c.2 0 .5.1.7.2.4.4.5 1 .1 1.4l-5.5 6.4 5.5 6.3c.4.4.3 1.1-.1 1.4-.4.4-1.1.3-1.4-.1l-6-7c-.3-.4-.3-.9 0-1.3l6-7c.1-.2.4-.3.7-.3z" />,
  'ChevronLeft',
  24,
  undefined,
  true
)
